// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import MPFamilyInfo from '../components/common/MPFamilyInfo';
import { useMPFamilyContext } from '../contexts/MPFamilyContext';
import { selectMPFamilyInfo } from '../selectors/families';
import { selectHasMPUserCompletedFamily, selectMPUserFamilyWonAmount } from '../selectors/user';

type MPFamilyInfoProps = {
  className?: string;
};

const MPFamilyInfoContainer = (ownProps: MPFamilyInfoProps) => {
  const { familyId } = useMPFamilyContext();

  const selectorProps = useMemo(() => ({ familyId }), [familyId]);
  const isCompleted = useSelector((state) => selectHasMPUserCompletedFamily(state, selectorProps));
  const familyInfo = useSelector((state) => selectMPFamilyInfo(state, selectorProps));
  const wonAmount = useSelector((state) => selectMPUserFamilyWonAmount(state, selectorProps));

  const selectedProps = useMemo(
    () => (familyInfo ? { ...familyInfo.eligibility, ...familyInfo.rules, wonAmount, isCompleted } : {}),
    [familyInfo, isCompleted, wonAmount],
  );

  const enhancedProps = useMergeProps({ selectedProps, ownProps });

  return familyInfo ? <MPFamilyInfo {...enhancedProps} /> : null;
};

export default MPFamilyInfoContainer;
